import { getCustomerReviewSettings } from '@/redux/actions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSSRSelector } from '@/redux/ssrStore';
import dynamic from 'next/dynamic.js';
import { getAuthToken } from '@/utils/getAuthToken';
import { RootState } from '@/redux/reducers';
import { AUTH_TOKEN } from '@/utils/constants';

const AuthModal = dynamic(() => import('@/components/DesignSystem/AuthPopUp'));

export const AuthenticateUserModal = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    showAuthModel: false,
  });

  const { user } = useSelector((state: RootState) => ({
    user: state.userReducer,
  }));

  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  useEffect(() => {
    const authToken = getAuthToken();

    if (authToken && storeData?.store_id) {
      dispatch(getCustomerReviewSettings(storeData.store_id));
    } else {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage?.setItem('deliveryType', '');
      setState({ showAuthModel: true });
    }
  }, [storeData?.store_id]);

  const toggleAuthModal = () => {
    if (!user?.isLogin) {
      setState({ showAuthModel: !state.showAuthModel });
      return;
    }

    if (!state.showAuthModel) {
      return;
    }

    setState({ showAuthModel: false });
  };

  if (!state.showAuthModel) {
    return null;
  }

  return <AuthModal toggleModal={toggleAuthModal} isVisible={state.showAuthModel} />;
};
